import React from 'react';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';
import Group from '../group';
import type { Props } from './types';

export default function StickyGroup({ scope, stickyHeader }: Props) {
	if (!isDefined(stickyHeader)) return null;
	const item = scope[stickyHeader.index];
	if (!isDefined(item)) return null;

	return <Group item={item} isStickyGroupHeader />;
}
